import { render, staticRenderFns } from "./auditAuthOwnerList.vue?vue&type=template&id=3b08581f&scoped=true"
import script from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
export * from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
import style0 from "./auditAuthOwnerList.vue?vue&type=style&index=0&id=3b08581f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08581f",
  null
  
)

export default component.exports